export default __webpack_public_path__ + "static/media/HDTX_Keterbukaan Informasi 28 Oktober 2022.09963321.pdf";